module.exports = __webpack_public_path__ + "img/exercise.011036b0.svg";